
















































































import { Component, Prop, Vue } from "vue-property-decorator";
import { userModule } from "@/store/modules/user";
import SoapRanapStore from "@/store/modules/SoapRanapStore";
import CpptRanapStore from "@/store/modules/CpptRanapStore";
import RegisterKunjungan from "@/store/modules/RegisterKunjungan";
import { storeSoap } from "@/store/modules/soap";
import { storeResume } from "@/store/modules/resume";
import { storeSpri } from "@/store/modules/spri";
import { storeRujukan } from "@/store/modules/rujukan";
import CardCatatanSoap from "@/components/pemeriksaan/soap/CardCatatanSOAP.vue";
import AdimeInput from "@/components/soap/AdimeInput.vue";
import HandOverInput from "@/components/soap/HandOverInput.vue";
import ReadBackInput from "@/components/soap/ReadBackInput.vue";
import CpptIntegratedList from "@/components/soap/CpptIntegratedList.vue";
import SoapInput from "@/components/soap/SoapInput.vue";

@Component({
  components: {
    CardCatatanSoap,
    AdimeInput,
    HandOverInput,
    ReadBackInput,
    CpptIntegratedList,
    SoapInput
  },
  inject: {
    pageIsReadOnly: { from: "isReadOnly", default: () => () => false }
  }
})
export default class CpptRalanPage extends Vue {
  @Prop() register!: string;
  @Prop() rm!: string;
  @Prop({ default: null }) copySoap!: object;
  @Prop({ type: String, default: "tab-soap" }) readonly defaultTab!: string;
  pageIsReadOnly!: () => boolean;

  tab = this.defaultTab;

  soapItem = null;
  adimeItem = null;
  handoverItem = null;
  readbackItem = null;
  salinanSoap: any = null;


  mounted() {
    if (!this.register) return;

    storeSpri.act_spri_on_reg(this.register);
    storeRujukan.act_rujukan_on_reg(this.register);
  }

  get soapMulti(): boolean {
    return ["2H", "38"].includes(this.stateUser.unit_id);
  }

  get isReadonly(): boolean {
    return this.pageIsReadOnly();
  }

  get stateUser() {
    return userModule.user;
  }

  get registerId(): number {
    return parseInt(this.$route.params.register);
  }

  get statesoapdata() {
    return storeSoap.soap["data"] ? storeSoap.soap["data"][0] : null;
  }

  get registerKunjungan() {
    return RegisterKunjungan.register;
  }

  get isDpjp(): boolean {
    return this.registerKunjungan?.dokter?.id == this.stateUser.id;
  }

  get adaResume(): boolean {
    return (
      String(storeResume.registerId) === String(this.register) &&
      storeResume.resume.length > 0
    );
  }

  get memuatResume(): boolean {
    return storeResume.loading;
  }

  get bisaBukaResume(): boolean {
    return this.stateUser.profesi === "Dokter";
  }

  get labelTombolResume(): string {
    return this.adaResume ? "Ubah Resume Ralan" : "Buat Resume Ralan";
  }

  segarkanRiwayat() {
    const riwayat = this.$refs.riwayat as any;
    if (riwayat && riwayat.fetchData) riwayat.fetchData();
  }

  /**
   * Resume Rawat Jalan bukan lagi modal — tombol ini memindahkan halaman ke tab
   * **Resume & Surat Keterangan → Resume Rawat Jalan** lewat mekanisme deep-link
   * universal (`Pemeriksaan.onOpenForm`), dengan `bukaForm` supaya form-nya
   * langsung terbentang tanpa klik kedua.
   */
  bukaHalamanResume() {
    this.$emit("pageTabResume", {
      topTab: "tab-suket",
      elemId: "tab-resume",
      category: "Resume & Rawat",
      bukaForm: true
    });
  }

  async getByRegister() {
    if (this.stateUser.isMedis) {
      await SoapRanapStore.getByRegister(this.registerId);
      await CpptRanapStore.getAdimeByRegister(this.registerId);
      await CpptRanapStore.getReadbackByRegister(this.registerId);
    } else {
      await CpptRanapStore.getHandoverByRegister(this.registerId);
    }
  }

  makeNewSoap(cat = "soap") {
    const key = `${cat}Item`;
    if (key in this) {
      this.tab = `tab-${cat}`;
      this[key] = null;
    } else if (cat === "soap") {
      this.tab = "tab-soap";
    }
  }

  putItem(cat: string, item: any) {
    const key = `${cat}Item`;
    if (key in this) {
      this.tab = `tab-${cat}`;
      this.$nextTick(() => {
        setTimeout(() => {
          this[key] = item;
        }, 100);
      });
    }
  }

  putSoapItem(item) {
    this.tab = "tab-soap";

    this.$nextTick(() => {
      setTimeout(() => {
        if (this.soapMulti) {
          this.soapItem = item;
        } else {
          this.salinanSoap = item;
        }
      }, 100);
    });
  }
}
